import PropTypes from 'prop-types';

export const FilterPropTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  visibleItems: PropTypes.number,
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  currencyCode: PropTypes.string,
  isMobile: PropTypes.bool,
};

export const FilterDefaultProps = {
  className: '',
  isMobile: false,
  visibleItems: undefined,
};
